(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["paydot-design-catalog"] = factory();
	else
		root["paydot-design-catalog"] = factory();
})(globalThis, () => {
return 